import { tabClasses, tabsClasses, TabsProps } from '@mui/material';
import { type Theme } from '@mui/material/styles';

declare module '@mui/material/Tabs' {
  interface TabsOwnProps {
    size?: 'small' | 'medium' | 'large';
    // tabOrientation?: 'vertical' | 'horizontal';
  }
}

export function getTabMarginStyles(theme: Theme, fullWidth?: boolean) {
  if (!fullWidth) {
    return {
      '&:not(:last-child)': {
        marginRight: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
          marginRight: theme.spacing(1),
        },
      },
    };
  }
  return {
    margin: 0,
  };
}

export default function Tabs(theme: Theme) {
  const rootStyles = (ownerState: TabsProps) => {
    const standardVariant = ownerState.variant === 'standard';
    const fullWidthVariant = ownerState.variant === 'fullWidth';
    const tabsVertical = ownerState.orientation === 'vertical';
    // const tabVertical = ownerState.tabOrientation === 'vertical';

    const smallSize = ownerState.size === 'small';
    const mediumSize = ownerState.size === 'medium';
    const largeSize = ownerState.size === 'large';

    const height =
      fullWidthVariant && tabsVertical
        ? 'auto'
        : smallSize
        ? 24
        : largeSize
        ? 48
        : 32;

    const defaultStyle = {
      minHeight: height,
      height: height,
      maxWidth: '100%',
      width: fullWidthVariant ? '100%' : 'unset',

      [`& > .${tabsClasses.scrollButtons}`]: {
        width: 48,
        borderRadius: '50%',
      },
      [`& > .${tabsClasses.scroller} > .${tabsClasses.flexContainer}`]: {
        minHeight: height,
        height: height,
      },
      [`& > .${tabsClasses.scroller} > .${tabsClasses.indicator}`]: {},
      [`& > .${tabsClasses.scroller} > .${tabsClasses.flexContainer} .${tabClasses.root}`]:
        {
          justifyContent: tabsVertical ? 'space-between' : 'center',
          minHeight: tabsVertical ? '36px' : height,
          fontSize: smallSize
            ? theme.typography.pxToRem(14)
            : theme.typography.pxToRem(14),
          ...getTabMarginStyles(theme, fullWidthVariant),
        },
    };

    return defaultStyle;
  };

  return {
    MuiTabs: {
      defaultProps: {},

      styleOverrides: {
        root: ({ ownerState }: { ownerState: TabsProps }) =>
          rootStyles(ownerState),
      },
    },

    MuiTab: {
      defaultProps: {
        disableRipple: true,
        iconPosition: 'start',
      },
    },
  };
}
